import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import { LoginService } from '../../login/services/login.service';

/**
 * Component for managing a user's account password.
 */
@Component({
	selector: 'user-password',
	templateUrl: './password.component.html',
	styleUrl: './password.component.css'
})
export class PasswordComponent implements OnInit {

	LOCALIZATION: any;

	validPass: boolean = false;
	popoverHTML!: SafeHtml;
	showPolicy: boolean = false;

	input = {
		oldpass: '',
		newpass: '',
		newpass2: ''
	}

	constructor(
		private sanitizer: DomSanitizer,
		private alertsService: AlertsService,
		private userService: UserService,
		private loginService: LoginService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.initValidation();
	}
	
	private initValidation(): void {
		this.createValidationResponse();
	}

	private createValidationResponse(): void {
		let html = this.loginService.getValidationResponse(this.validPass);
		this.popoverHTML = this.sanitizer.bypassSecurityTrustHtml(html);
	}

	validatePassword(): string {
		this.validPass = this.loginService.passwordValidate(this.input.newpass);
		this.createValidationResponse();
		return this.loginService.getValidationErrors();
	}

	updatePassword(): void {
		if (!this.input.oldpass || !this.input.newpass || !this.input.newpass2) {
			this.alertsService.error({
				message: this.LOCALIZATION.fillAllFields,
				delay: 5000
			});
			return;
		}

		if (this.input.newpass != this.input.newpass2) {
			this.alertsService.error({
				message: this.LOCALIZATION.loginPasswordsNoMatch,
				delay: 5000
			});
			return;
		}

		let validationErrors = this.validatePassword();
		if (!this.validPass) {
			this.alertsService.error({
				message: this.LOCALIZATION.loginPasswordNoValidation + "\n" + validationErrors,
				delay: 5000
			});
			return;
		}

		let payload = {
			username: this.userService.user.username,
			password: this.input.newpass,
			email: this.userService.user.email
		};

		this.userService.updatePassword(payload, this.input.oldpass, false).then(
			(response: any) => {
				this.alertsService.success({
					message: "Password has been updated.",
					delay: 5000
				});

				this.input.oldpass = '';
				this.input.newpass = '';
				this.input.newpass2 = '';
			},
			(err: any) => {
				console.error("Failed to update user password.", err);
				this.alertsService.error({
					title: "Update Failed",
					message: err,
					delay: 5000
				});
			}
		);
	}
}
